import * as React from 'react';

import InputArray from 'components/inputs/input-array/InputArray';
import ActionButton from 'components/buttons/action-button/ActionButton';

import DiscoveryContentSort from 'modules/discovery/content/components/sort/DiscoveryContentSort';

import { getUniqueSearchTerms } from 'modules/discovery/content/utils/content';
import { getPrefix } from 'utils/helper/common';
import { __t, applyTranslations } from 'utils/language';

import './inspirational-materials-discovery-filters.scss';

applyTranslations(require('./inspirational-materials-discovery-filters.i18n.json'));

type Props = {
  sort: string,
  searchTerms: Array<string>,
  onTriggerSearch: () => void,
  onUpdateSearchTerms: (a: Array<string>) => void,
  onUpdateSort: (a: string) => void
};

function mapSearchTerms(input: Array<string>): Array<string> {
  return input.map(value => (
    getPrefix(value) ? value : `#${value}`
  ));
}

const InspirationalMaterialsDiscoveryFilters = (
  {
    sort,
    searchTerms,
    onTriggerSearch,
    onUpdateSearchTerms,
    onUpdateSort
  }: Props
): JSX.Element => {
  const uniqueSearchTerms = getUniqueSearchTerms(searchTerms);

  return (
    <section className="inspirational-materials-discovery-filters">
      <div className="inspirational-materials-discovery-filters__search">
        <div className="inspirational-materials-discovery-filters__search-terms">
          <InputArray
            name="discovery-content-search-input"
            placeholder={__t('inspirational_materials_discovery_filters.search_placeholder')}
            value={uniqueSearchTerms}
            max={20}
            size="normal"
            onChange={(input) => onUpdateSearchTerms(mapSearchTerms(input))}
          />
        </div>
        <ActionButton
          onClick={onTriggerSearch}
          className="inspirational-materials-discovery-filters__search-button"
        >
          {__t('inspirational_materials_discovery_filters.search_label')}
        </ActionButton>
      </div>
      <div className="inspirational-materials-discovery-filters__sort-options">
        <DiscoveryContentSort
          sort={sort}
          onSort={onUpdateSort}
        />
      </div>
    </section>
  );
};

export default InspirationalMaterialsDiscoveryFilters;
